export default __webpack_public_path__ + "19abc9d8ff19618a208922d6560ed2fe.svg";